import { useState } from 'react';
import { downloadResalePdf } from '../lib/resalePdf';
import {
  publicResalePreviewUrl,
  publicResaleReportUrl,
  resaleShareMessage,
  whatsAppShareUrl,
} from '../lib/resaleReportUrl';
import { supabase } from '../lib/supabase';

function qrImageUrl(url) {
  return `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(url)}`;
}

export default function ResaleReportActions({ report, onRefresh }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState('');
  const [showQr, setShowQr] = useState(false);
  const [published, setPublished] = useState(report);

  const shareUrl = published.share_token
    ? publicResaleReportUrl(published.share_token)
    : null;
  const previewUrl = published.share_token
    ? publicResalePreviewUrl(published.share_token)
    : null;

  async function publishShare() {
    setBusy(true);
    setError('');
    const { data, error: rpcError } = await supabase.rpc(
      'publish_resale_inspection_share',
      { p_report_id: published.id, p_expires_days: 90 }
    );
    setBusy(false);
    if (rpcError) {
      setError(rpcError.message);
      return;
    }
    setPublished(data);
    onRefresh?.(data);
    const url = publicResaleReportUrl(data.share_token);
    try {
      await navigator.clipboard.writeText(url);
      setOk('Buyer link published and copied.');
    } catch {
      setOk('Buyer link published.');
    }
  }

  async function revokeShare() {
    setBusy(true);
    setError('');
    const { data, error: rpcError } = await supabase.rpc(
      'revoke_resale_inspection_share',
      { p_report_id: published.id }
    );
    setBusy(false);
    if (rpcError) {
      setError(rpcError.message);
      return;
    }
    setPublished(data);
    onRefresh?.(data);
    setOk('Buyer link revoked.');
  }

  async function copyLink() {
    if (!shareUrl) return;
    await navigator.clipboard.writeText(shareUrl);
    setOk('Link copied.');
  }

  return (
    <div className="resale-report-actions">
      {error ? <p className="error">{error}</p> : null}
      {ok ? <p className="ok">{ok}</p> : null}

      <div className="row-actions">
        <button type="button" className="primary" disabled={busy} onClick={publishShare}>
          {shareUrl ? 'Refresh buyer link' : 'Publish buyer link'}
        </button>
        {shareUrl ? (
          <>
            <button type="button" className="ghost" disabled={busy} onClick={copyLink}>
              Copy link
            </button>
            <button type="button" className="ghost" onClick={() => setShowQr((v) => !v)}>
              {showQr ? 'Hide QR' : 'Show QR'}
            </button>
            <a
              className="ghost"
              href={whatsAppShareUrl(resaleShareMessage(published, previewUrl || shareUrl))}
              target="_blank"
              rel="noreferrer"
            >
              WhatsApp
            </a>
            <button type="button" className="ghost" disabled={busy} onClick={revokeShare}>
              Revoke
            </button>
          </>
        ) : null}
        <button
          type="button"
          className="ghost"
          disabled={busy}
          onClick={() => downloadResalePdf(published)}
        >
          Download PDF
        </button>
      </div>

      {showQr && shareUrl ? (
        <div className="resale-qr-card">
          <img src={qrImageUrl(shareUrl)} alt="Verification QR" />
          <p>
            Verification code: <strong>{published.verification_code}</strong>
          </p>
          <a href={shareUrl} target="_blank" rel="noreferrer">
            {shareUrl}
          </a>
        </div>
      ) : null}
    </div>
  );
}
